class Cookie {
    getCookie(name: string) {

        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ))
        return matches ? decodeURIComponent(matches[1]) : undefined
    }

    // уcтанавливает cookie
    setCookie(name: string, value: string | null, props: any) {

        props = props || {}

        var exp = props.expires

        if (typeof exp == "number" && exp) {

            var d = new Date()

            d.setTime(d.getTime() + exp * 1000)

            exp = props.expires = d

        }

        if (exp && exp.toUTCString) { props.expires = exp.toUTCString() }

        value = encodeURIComponent(value ? value : '')

        var updatedCookie = name + "=" + value

        for (var propName in props) {

            updatedCookie += "; " + propName

            var propValue = props[propName]

            if (propValue !== true) { updatedCookie += "=" + propValue }
        }

        document.cookie = updatedCookie

    }

    // удаляет cookie
    deleteCookie(name: string) {

        this.setCookie(name, null, { expires: -1 })

    }
}

export default new Cookie()